import axios from 'axios'

const node_env = {
    node_env: 'development',
    development: 'http://localhost:8081',//http://localhost:8081
}

axios.defaults.baseURL = node_env[node_env.development];
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//添加拦截器X-Requested-With: XMLHttpRequest

axios.interceptors.request.use(
    function (config) {
        // 设置统一请求头
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);
/**
 * 获取首页信息
 */
const getIndex = (param) => {
    return axios.get('/api/index/index', { params: param });
}
/**
 * 获取底部
 */
const getFoot = (param) => {
    return axios.get('/api/index/footer', { params: param });
}
/**
 * 获取语言列表
 */
const getLang = (param) => {
    return axios.get('/api/index/language', { params: param });
}
/**
 * 获取游戏列表
 */
const getGames = (param) => {
    return axios.get('/api/index/game', { params: param });
}
/**
 * 获取新闻
 */
const getNews = (param) => {
    return axios.get('/api/index/news', { params: param });
}
/**
 * 获取新闻详情
 */
const getNewsDetail = (param) => {
    return axios.get('/api/index/detail', { params: param });
}
/**
 * 关于我们
 */
const getAbout = (param) => {
    return axios.get('/api/index/about-us', { params: param });
}
/**
 * 加入我们（外文版）
 */
const getJoinUs = (param) => {
    return axios.get('/api/index/join-us', { params: param });
}
/**
 * 联系我们（外文版）
 */
const getContactUs = (param) => {
    return axios.get('/api/index/contact-us', { params: param });
}
/**
 * 家长监护|交易纠纷|隐私政策 页面类别 type: protect（家长监护）、 trade（交易纠纷）、privacy （隐私政策）
 */
const getCommonPage = (param) => {
    return axios.get('/api/index/common-page', { params: param });
}

export { getFoot, getNews, getAbout, getJoinUs, getContactUs, getCommonPage, getNewsDetail, getGames, getLang, getIndex }


























// WEBPACK FOOTER //
// ./src/common/api.js